if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.savedGender = localStorage.getItem('lastCollection')?.toLowerCase();

        if (this.savedGender?.startsWith('men')) {
          this.savedGender = 'men';
        } else if (this.savedGender?.startsWith('women')) {
          this.savedGender = 'women';
        } else {
          this.savedGender = null;
        }

        if (this.savedGender) {
          setTimeout(() => {
            const activeButton = document.querySelector(`[data-gender="${this.savedGender}"]`);
            if (activeButton) {
              activeButton.classList.add('active');
            }

            this.scrollToGenderMedia(this.savedGender);
            this.changeGenderInfoVisibility();
          }, 500);
        }

        document.querySelectorAll('[data-gender]').forEach((button) => {
          button.addEventListener('click', () => {
            const gender = button.dataset.gender;
            if (gender === 'men' || gender === 'women') {
              localStorage.setItem('lastCollection', gender);
              this.savedGender = gender;
              this.scrollToGenderMedia(gender);
              this.changeGenderInfoVisibility();
              document.querySelectorAll('[data-gender]').forEach((b) => b.classList.remove('active'));
              button.classList.add('active');
            }
          });
        });

        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 200));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', () => {
            if (this.elements.thumbnails.hasAttribute('vertical-slider') && window.innerWidth > 750) {
              this.activeMediaScrollIntoView(mediaToSwitch.dataset.target);
            }
            this.setActiveMedia(mediaToSwitch.dataset.target, false);
          });
        });
        if (this.elements.thumbnails.hasAttribute('vertical-slider')) {
          this.onScroll();
          window.addEventListener('scroll', this.onScroll.bind(this));
        }
        if (this.mql.matches) {
          this.removeListSemantic();
        }
        if (this.dataset.desktopLayout.includes('thumbnail')) {
          this.elements.thumbnails.style.setProperty(
            '--max-height',
            (this.elements.viewer.clientHeight > 312 ? this.elements.viewer.clientHeight : 312) + 'px'
          );
          this.hideThumbnailsSliderArrows();
          window.addEventListener('resize', () => {
            this.elements.thumbnails.style.setProperty(
              '--max-height',
              (this.elements.viewer.clientHeight > 312 ? this.elements.viewer.clientHeight : 312) + 'px'
            );
            this.hideThumbnailsSliderArrows();
          });
        }

        this.constrainedMedias = this.querySelectorAll('.product-media-container.constrain-height ');
        this.announcementBar = document.querySelector('.shopify-section-group-header-group.scrolling-text-section');
        this.constrainedMedias.forEach((constrainedMedia) => {
          let offsetTop = this.announcementBar
            ? this.offsetTop + this.announcementBar.getBoundingClientRect().height
            : this.offsetTop;
          constrainedMedia.style.setProperty('--viewport-offset', `${offsetTop}px`);
          window.addEventListener('resize', () => {
            offsetTop = this.announcementBar
              ? this.offsetTop + this.announcementBar.getBoundingClientRect().height
              : this.offsetTop;
            constrainedMedia.style.setProperty('--viewport-offset', `${offsetTop}px`);
          });
        });
      }

      changeGenderInfoVisibility() {
        const activeButton = document.querySelector('[data-gender].active');
        if (!activeButton) return;

        const gender = activeButton.dataset.gender;

        const allTargets = [
          '.fixed-media__women-video',
          '.fixed-media__men-video',
          '.fixed-media-content__model-size--women',
          '.fixed-media-content__model-size--men',
        ];

        allTargets.forEach((selector) => {
          document.querySelectorAll(selector).forEach((element) => element.classList.remove('visible'));
        });

        var countGenderVideos = document.querySelectorAll(`.fixed-media__${gender}-video`);
        const visibleTargets = [`.fixed-media__${gender}-video`, `.fixed-media-content__model-size--${gender}`];

        visibleTargets.forEach((selector) => {
          document.querySelectorAll(selector).forEach((element) => element.classList.add('visible'));
        });

        const contentElements = document.querySelectorAll('.fixed-media-content__model-size');
        let elementsToHide = [...contentElements];

        if (countGenderVideos.length > 0) {
          const featuredElements = document.querySelectorAll('.fixed-media__featured-media');
          elementsToHide = [...elementsToHide, ...featuredElements];
        }

        elementsToHide.forEach((element) => element.classList.add('hidden'));
      }

      scrollToGenderMedia(gender) {
        if (this.classList.contains('custom-media-gallery')) {
          const scrollContainer = document.querySelector('.product__media-wrapper--scrolled');
          if (!scrollContainer) return;

          const media = scrollContainer.querySelector(`li[data-gender="${gender}"]`);
          if (!media) return;

          const targetScrollTop = media.offsetTop - scrollContainer.offsetTop;

          scrollContainer.scrollTo({
            top: targetScrollTop,
            behavior: 'smooth',
          });
        } else {
          const sliderComponent = this.elements.viewer.closest('slider-component');
          if (!sliderComponent) return;

          const slider = sliderComponent.querySelector('[id^="Slider-"]');
          const media = slider.querySelector(`li[data-gender="${gender}"]`);
          if (!media) return;

          slider.scrollTo({
            left: media.offsetLeft,
            behavior: 'smooth',
          });
        }
      }

      onSlideChanged(event) {
        if (event.detail.currentElement) {
          const thumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
          );
          this.setActiveThumbnail(thumbnail);
        }
      }

      setActiveMedia(mediaId, prepend, scrollViewport = true) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia || activeMedia.classList.contains('is-active')) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            const behavior = this.elements.viewer.dataset.scrollBehavior
              ? this.elements.viewer.dataset.scrollBehavior
              : 'smooth';

            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: behavior });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            if (window.innerWidth >= 750) {
              if (scrollViewport) activeMedia.scrollIntoView({ behavior: 'smooth' });
            }
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      activeMediaScrollIntoView(mediaId) {
        const isSliderActive = this.dataset.sliderActive === 'true';
        if (isSliderActive) {
          return;
        }

        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);

        const isStickyHeader = document.querySelector('sticky-header') !== null;

        let scrollPosition;

        if (isStickyHeader) {
          let headerHeight = 0;
          if (document.querySelector('.header-wrapper')) {
            headerHeight = document.querySelector('.header-wrapper').getBoundingClientRect().bottom;
          }

          scrollPosition = window.scrollY + activeMedia.getBoundingClientRect().top - headerHeight - 24;
        } else {
          scrollPosition = window.scrollY + activeMedia.getBoundingClientRect().top - 24;
        }

        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth',
        });
      }

      onScroll() {
        if (window.innerWidth > 750) {
          this.elements.viewer.querySelectorAll('li[data-media-id]').forEach((element, index) => {
            if (
              (element.getBoundingClientRect().top > 0 &&
                element.getBoundingClientRect().top < window.innerHeight * 0.5) ||
              (element.getBoundingClientRect().bottom > 0 &&
                element.getBoundingClientRect().bottom < window.innerHeight * 0.5)
            ) {
              this.setActiveMedia(element.dataset.mediaId, false);
            }
          });
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        if (this.elements.thumbnails.hasAttribute('vertical-slider')) {
          if (this.elements.thumbnails.isSlideVisibleVertical(thumbnail, 10)) return;
          this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop, behavior: 'smooth' });
        } else {
          if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft, behavior: 'smooth' });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        // window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
      hideThumbnailsSliderArrows() {
        if (this.dataset.desktopLayout == 'thumbnail_slider') {
          const list = this.elements.thumbnails.querySelector('.thumbnail-list');
          const listElements = list.querySelectorAll('.thumbnail-list__item');
          const buttons = this.elements.thumbnails.querySelectorAll('.slider-button');
          if (this.elements.thumbnails.hasAttribute('vertical-slider')) {
            let listHeight = 0;
            listElements.forEach((item, index) => {
              listHeight += item.clientHeight;
              if (index != 0) listHeight += 10;
            });

            if (list.clientHeight >= listHeight) {
              buttons.forEach((b) => {
                b.classList.add('hidden');
              });
            } else {
              buttons.forEach((b) => {
                b.classList.remove('hidden');
              });
            }
          } else {
            let listWidth = 0;
            listElements.forEach((item, index) => {
              listWidth += item.clientWidth;
              if (index != 0) listWidth += 10;
            });

            if (list.clientWidth >= listWidth) {
              buttons.forEach((b) => {
                b.classList.add('hidden');
              });
            } else {
              buttons.forEach((b) => {
                b.classList.remove('hidden');
              });
            }
          }
        }
      }
    }
  );
}
